<template>
  <v-row justify="center">
    <v-dialog
      @keydown.esc="closeModal()"
      max-width="500px"
      :value="isVisible"
      v-on:click:outside="closeModal"
      overlay-opacity="1"
      transition="slide-y-transition"
    >
      <v-card flat tile elevation="0">
        <v-toolbar
          class="black--text d-flex justify-center"
          color="#fbc501"
          tile
        >
          <v-toolbar-title>Przedłuż subskrypcję</v-toolbar-title>
        </v-toolbar>
        <BlackButton
          fab
          small
          icon="times"
          iconMargin=""
          class="close"
          @click.native="closeModal()"
        />
        <v-card flat tile elevation="0" v-if="!subscriptionExpired">
          <div class="justify-center text-center my-6">
            <h3>Twoja subskrypcja wygasa</h3>
            <h3>{{ formatDate(expirationDate) }}</h3>
          </div>
          <v-card-actions class="justify-center"
            ><YellowButton width="30%" text="OK" @click.native="closeModal()"
          /></v-card-actions>
        </v-card>
        <v-card flat tile elevation="0" v-else>
          <v-card-title class="justify-center"
            >Twoja subskrypcja wygasła</v-card-title
          >
          <v-card-actions class="justify-center"
            ><YellowButton
              width="60%"
              text="Przedłuż subskrypcję"
              @click.native="goToSubscription()"
          /></v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BlackButton from "../buttons/BlackButton";
import YellowButton from "../buttons/YellowButton";
import shared from "../../shared";
import moment from "moment";
export default {
  name: "SubscriptionModal",
  props: ["isVisible", "hours", "expirationDate"],

  components: {
    BlackButton,
    YellowButton,
  },
  data: () => ({}),
  computed: {
    contacts() {
      return this.$store.getters["user/getContacts"];
    },
    subscriptionExpired() {
      moment.locale("pl");
      return moment(this.expirationDate).isBefore(moment());
    },
  },
  methods: {
    formatDate(date) {
      return `${shared.formattedDate(
        date
      )} o ${shared.formattedTimeWithoutSeconds(date)}`;
    },
    goToSubscription() {
      this.$router.push("/subscription");
      this.closeModal();
    },
    getTime(date) {
      return shared.formattedTime(date);
    },
    markAsDone(item) {
      this.$store.dispatch("customers/markContactAsDone", item.id);
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
<style lang="scss" scoped>
.outlined-form-section {
  position: relative;

  border-color: rgba(0, 0, 0, 0.38);
  border-width: 2px;
}

.outlined-form-section-title {
  top: -15px;
  left: 10px;
  position: absolute;

  padding: 0.2rem 0.5rem;

  background-color: white;

  font-size: 12px;
}
// .v-overlay__scrim {
//   backdrop-filter: blur(5px) !important;
//   background-color: transparent !important;
// }
.close {
  position: absolute;
  top: 2%;
  right: 3%;
  z-index: 10000000;
}
.noSelect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
</style>
